module.exports = __webpack_public_path__ + "img/icon_cusser_web.66be4b4a.svg";